import React from 'react';

import { UiButton } from '../ui/ui-button';

import { CalendlyHyperlink } from './hris-integration-response-schedule-meeting';

import { MergeLinkButton } from '../merge-integration/widgets/merge-link-button';

type InputProps = {
  hrisIntegrationResponse?: HrisIntegrationResponse;
  org: Org;
  handlePrevious: () => void;
  handleClose: () => void;
};

export const HrisIntegrationResponseSync = ({
  hrisIntegrationResponse,
  org,
  handlePrevious,
  handleClose,
}: InputProps) => {
  const { HrisIntegrationType: { integrationName } = { integrationName: undefined } } =
    hrisIntegrationResponse || {};
  if (!integrationName) {
    return null;
  }

  const getSmartlookClickInfo = (action: string) => ({
    eventName: 'HRIS response dialog click',
    props: {
      component: 'sync',
      integrationName,
      action,
    },
  });

  return (
    <>
      <div className="u-margin-top">We&apos;re excited to get your HR/Payroll sync set up!</div>
      <div className="u-margin-top">
        Follow the prompts to set up the sync yourself or&nbsp;
        <CalendlyHyperlink text="schedule a quick setup call with our Customer Success team" />
        &nbsp;for help.
      </div>
      <div className="u-flex-center u-margin-top u-justifyContent-spaceBetween">
        <UiButton
          variant="tertiary"
          size="sm"
          onClick={handlePrevious}
          smartlookEvent={getSmartlookClickInfo('previous')}
        >
          Previous
        </UiButton>
        <MergeLinkButton
          mergeIntegrationKey={hrisIntegrationResponse?.HrisIntegrationType?.mergeIntegrationKey}
          isIntegrated={false}
          orgId={org.org_id}
          size="sm"
          variant="primary"
          onExit={handleClose}
        />
      </div>
    </>
  );
};
